import Gift from "components/About/Gift";

export default Gift;



// WEBPACK FOOTER //
// ./src/containers/About/Gift/index.js